import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, MapPin, Building2, Users, Search } from "lucide-react";
import api from "../lib/api";

export default function SearchWidget({ initial = {}, compact = false }) {
  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [date, setDate] = useState(initial.date || "2027-08-15");
  const [city, setCity] = useState(initial.city || "");
  const [district, setDistrict] = useState(initial.district || "");
  const [category, setCategory] = useState(initial.category || "");
  const [guests, setGuests] = useState(initial.guests || "");
  const [meal, setMeal] = useState(initial.meal || "");

  useEffect(() => {
    api.get("/locations").then((r) => setLocations(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCategories(r.data.filter((c) => !c.parent_id))).catch(() => {});
  }, []);

  const districts = locations.find((l) => l.city === city)?.districts || [];

  const submit = (e) => {
    e.preventDefault();
    const p = new URLSearchParams();
    if (date) p.set("date", date);
    if (city) p.set("city", city);
    if (district) p.set("district", district);
    if (category) p.set("category", category);
    if (guests) p.set("guests", guests);
    if (meal) p.set("meal", meal);
    navigate(`/ara?${p.toString()}`);
  };

  return (
    <form data-testid="hero-search-bar" onSubmit={submit}
      className={`card p-4 sm:p-6 grid gap-4 ${compact ? "grid-cols-2 lg:grid-cols-7" : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-7"}`}>
      <div className={compact ? "" : "sm:col-span-1"}>
        <label className="label"><CalendarDays size={12} className="inline mr-1" />Etkinlik Tarihi</label>
        <input data-testid="search-date-picker" type="date" className="input" value={date} onChange={(e) => setDate(e.target.value)} />
      </div>
      <div>
        <label className="label"><MapPin size={12} className="inline mr-1" />İl</label>
        <select data-testid="search-city-select" className="input" value={city} onChange={(e) => { setCity(e.target.value); setDistrict(""); }}>
          <option value="">Tüm İller</option>
          {locations.map((l) => <option key={l.city} value={l.city}>{l.city}</option>)}
        </select>
      </div>
      <div>
        <label className="label"><Building2 size={12} className="inline mr-1" />İlçe</label>
        <select data-testid="search-district-select" className="input" value={district} onChange={(e) => setDistrict(e.target.value)} disabled={!city}>
          <option value="">Tüm İlçeler</option>
          {districts.map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
      </div>
      <div>
        <label className="label">Kategori</label>
        <select data-testid="search-category-select" className="input" value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="">Tüm Kategoriler</option>
          {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <div>
        <label className="label">Yemek</label>
        <select data-testid="search-meal-select" className="input" value={meal} onChange={(e) => setMeal(e.target.value)}>
          <option value="">Farketmez</option>
          <option value="yemekli">Yemekli</option>
          <option value="yemeksiz">Yemeksiz</option>
        </select>
      </div>
      <div>
        <label className="label"><Users size={12} className="inline mr-1" />Misafir Sayısı</label>
        <select data-testid="search-guest-count" className="input" value={guests} onChange={(e) => setGuests(e.target.value)}>
          <option value="">Farketmez</option>
          {[50, 100, 200, 300, 500, 1000].map((g) => <option key={g} value={g}>{g} kişi</option>)}
        </select>
      </div>
      <div className="flex items-end">
        <button data-testid="search-submit-btn" type="submit" className="btn-gold w-full">
          <Search size={16} /> Müsaitleri Bul
        </button>
      </div>
    </form>
  );
}
